export default class LeaveTeamEditor {
  constructor(context) {
    this.context = context;
  }

  run(teamId) {
    if (teamId) {
      this.context.stores.teams.clearErrors(teamId);
      this.context.stores.teams.resetPending(teamId);
    } else {
      this.context.stores.teams.clearErrorsForNew();
      this.context.stores.teams.resetPendingNew();
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/teams/leave_team_editor.js